import { isDOM } from '@app/shared/predicates'

import LiveInputsService from '../services/live-inputs-service'

export default (): void => {
  window.onDomLoad(($dom) => {
    const service = LiveInputsService()
    service.buildInstances($dom[0])
    const instance = service.instance

    if (!instance || !isDOM($dom[0])) {
      return
    }

    if (instance.supportsAsyncTemplateRendering()) {
      void instance.initAsyncRendering()
    } else {
      instance.completeInitialization()
    }
  })
}
